class BESSAppProjectChart extends BESSAppBase {

    constructor(identifier) {
        super();
        this.chartView = $('#' + identifier);
        let container = this.chartView.find('.app-chart-container');
        this.chartContainer = container.length > 0 ? container : this.chartView;
        this.isValid = this.chartView.length > 0;
    }

    _renderPieChart(chartData) {
        this.chartContainer.highcharts(
            {
                chart: {},
                legend: {
                    align: 'right',
                    verticalAlign: 'top',
                    layout: 'vertical',
                },
                colors: this._colors(),
                credits: {
                    enabled: false
                },
                title: {
                    text: null
                },
                subtitle: {
                    text: null
                },
                tooltip: {
                    pointFormat: '{point.percentage:.1f}%'
                },
                plotOptions: {
                    pie: {
                        animation: false,
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true
                    }
                },
                series: [{
                    type: 'pie',
                    data: chartData
                }]
            });
    }

    _colors() {
        return [
            '#a24728',
            '#bc712f',
            '#389aa6',
            '#956e26',
            '#81173b',
            '#43749a',
            '#71681f',
            '#559442',
            '#4a6b3e',
            '#534e71'
        ];
    }
}